import NOOP from 'lodash/noop';
import { authActions } from '@ott/auth';

let getUserInfoPromise = null;

export default () =>
  function (dispatch) {
    if (!getUserInfoPromise) {
      getUserInfoPromise = dispatch(authActions.getBasicUserInfo()).then(NOOP, () => {
        getUserInfoPromise = null;
      });
    }

    return getUserInfoPromise;
  };
